const buildFormField = (sequence, alias, name, type, required = false,
  configObject = {}, paramsObject = {}, dependencyObject = {}) => ({
  alias,
  sequence,
  name,
  required,
  type: { name: type },
  config: configObject,
  params: paramsObject,
  dependency: dependencyObject,
});

const sizes = (sm, md, lg, xl) => ({
  sm, md, xl, lg,
});

const FieldTypes = {
  EMAIL: 'email',
  EMAILSAS: 'emailsas',
  TEXT: 'text',
  TEXTROOM: 'textroom',
  RADIO: 'radio',
  SWITCH: 'switch',
  TEL: 'tel',
  MOBILE: 'mobile',
  SELECT: 'select',
  SEARCH: 'search',
  DESCRIPTION: 'description',
};

const REQUIRED = true;

const configProfileForm = {
  // default fields form
  defaultFields: [
    buildFormField(1, 'userid', 'Usuario', FieldTypes.TEXT, !REQUIRED, {
      initialvalue: '#user.userid',
      inline: 'true',
      disabled: 'true',
      size: sizes(6, 4, 4, 3),
    }, {
      hidden: 'true',
    }),
    buildFormField(2, 'pass', 'Caducidad contraseña', FieldTypes.TEXT, !REQUIRED, {
      initialvalue: '',
      inline: 'true',
      disabled: 'true',
      size: sizes(6, 4, 4, 3),
    }),
    buildFormField(3, 'position', 'Categoría profesional', FieldTypes.TEXT, !REQUIRED, {
      initialvalue: "(#user.position? #user.position.name : '' )",
      inline: 'true',
      disabled: 'true',
      size: sizes(6, 4, 4, 3),
    }),
    buildFormField(4, 'tamano', 'Tamaño buzon', FieldTypes.TEXT, !REQUIRED, {
      initialvalue: '',
      inline: 'true',
      disabled: 'true',
      size: sizes(6, 4, 4, 3),
    }),
    buildFormField(5, 'location', 'Centro de trabajo', FieldTypes.SEARCH, REQUIRED, {
      initialvalue: '#user.location.id',
      inline: 'true',
      size: sizes(6, 4, 4, 3),
    }, {
      entity: 'loc',
      match: 'name,state.name',
      fields: 'id,name,state.id,state.name',
      filters: '{"delete_flag":0}',
      lookandfeel: '#item.name #item.state.name::[ ($1)]',
      target: 'backend',
      order: 'location_name',
    }),
  ],
  dirayaFields: [
    buildFormField(4, 'emailAddress', 'Email', FieldTypes.EMAIL, !REQUIRED, {
      initialvalue: '#user.emailAddress',
      inline: 'true',
      size: sizes(6, 4, 4, 3),
    }),
  ],
  phoneFields: [
    buildFormField(11, 'agesconField', 'Móvil para recuperar la contraseña DMSAS', FieldTypes.TEXT, !REQUIRED, {
      initialvalue: "#user?.agesconPhone ? '******' + #user?.agesconPhone?.substring(6, #user?.agesconPhone?.length) : ''",
      inline: 'true',
      disabled: 'true',
      size: sizes(6, 4, 4, 3),
    }, {}, {
      visibility: '#user?.agesconPhone.length!=0',
    }),
    buildFormField(12, 'mobilePhone', 'Móvil de contacto', FieldTypes.MOBILE, !REQUIRED, {
      initialvalue: '#user?.agesconPhone != #user?.mobilePhone ? #user?.mobilePhone : #user?.agesconPhone',
      inline: 'true',
      size: sizes(6, 4, 4, 3),
    }, { deleted: 'true', isEmpty: 'true' }, {
      visibility: '#mobilePhoneSwitch?.value != true',
    }),
    buildFormField(13, 'agesconPhone', 'Móvil de contacto', FieldTypes.MOBILE, !REQUIRED, {
      initialvalue: '#user?.agesconPhone',
      inline: 'true',
      size: sizes(6, 4, 4, 3),
    }, { isEmpty: 'true' }, {
      update: 'IsAgesconCopied, mobilePhoneSwitch',
      visibility: '#mobilePhoneSwitch?.value === true',
    }),
    buildFormField(14, 'phoneNumber', 'Otro teléfono de contacto', FieldTypes.TEL, !REQUIRED, {
      initialvalue: '#user.phoneNumber',
      inline: 'true',
      size: sizes(6, 4, 4, 3),
    }, {}, {}),
    buildFormField(15, 'isWhatsappAllowed', 'Habilitar móvil de contacto para identificarme cada vez que contacte con ayudaDIGITAL (WhatsApp y teléfono)', FieldTypes.SWITCH, !REQUIRED, {
      inline: 'true',
      initialvalue: "#user?.isWhatsappAllowed === '201' || #user?.isWhatsappAllowed === 201 ? true : false",
      size: sizes(12, 12, 12, 12),
    }, {}, {}),
    buildFormField(16, 'emailAddress', 'Correo electrónico', FieldTypes.EMAIL, !REQUIRED, {
      initialvalue: '#user.emailAddress',
      inline: 'true',
      size: sizes(6, 4, 4, 3),
    }),
  ],
  //--------------
  personalInfo: [
    buildFormField(31, 'middleName', 'Nombre', FieldTypes.TEXT, !REQUIRED, {
      initialvalue: '#user.middleName',
      inline: 'true',
      disabled: 'true',
      size: sizes(6, 4, 4, 3),
    }),
    buildFormField(32, 'lastName', 'Apellidos', FieldTypes.TEXT, !REQUIRED, {
      // eslint-disable-next-line no-template-curly-in-string
      initialvalue: '`${#user.lastName ? #user.lastName + " " : #user.lastName}${#user.firstName || ""}`',
      inline: 'true',
      disabled: 'true',
      size: sizes(6, 4, 4, 3),
    }),
    buildFormField(33, 'dni', 'NIF', FieldTypes.TEXT, !REQUIRED, {
      initialvalue: '#user.dni',
      inline: 'true',
      disabled: 'true',
      size: sizes(6, 4, 4, 3),
    }, {
      hidden: 'true',
    }),
  ],

};
export { configProfileForm as default };
